import dayjs from 'dayjs';
import Hotjar from '@hotjar/browser';
import Cookies from 'js-cookie';

import { IS_HOTJAR_ENABLED } from 'constants/constants';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';
import { PreQualificationStep } from 'enums/PreQualificationStep';
import {
  MARKETING_URL_PARAM_NAMES,
  MARKETING_URL_PARAMS_CACHE_DAYS,
  CONCEPTUAL_DEVICE_ID_COOKIE,
  GET_CONCEPTUAL_DEVICE_ID_MAX_ATTEMPTS,
  GET_CONCEPTUAL_DEVICE_ID_RETRY_DELAY_MS,
} from 'prequalificationV2/routes/routes.constants';

export const cacheUrlMarketingParamsToCookie = () => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search.slice(1));
  const expirationDate = dayjs().add(MARKETING_URL_PARAMS_CACHE_DAYS, 'days').toDate();

  MARKETING_URL_PARAM_NAMES.forEach((marketingUrlParamName) => {
    const marketingUrlParam = params.getAll(marketingUrlParamName)[0];

    if (marketingUrlParam) {
      Cookies.set(marketingUrlParamName, marketingUrlParam, {
        expires: expirationDate,
      });
    }
  });
};

export const removeUrlMarketingParamsFromCookie = () => {
  MARKETING_URL_PARAM_NAMES.forEach((marketingUrlParamName) => {
    Cookies.remove(marketingUrlParamName);
  });
};

export const triggerHotjarEvent = (urlPathName: string, currentPreQualificationStep: PreQualificationStep | null) => {
  if (!IS_HOTJAR_ENABLED) {
    return;
  }

  let hotjarAction = '';

  if (urlPathName === AppRoutes.Prequalification) {
    hotjarAction = urlPathName + currentPreQualificationStep;
  } else if (urlPathName.includes(AppRoutes.ResetPassword)) {
    hotjarAction = AppRoutes.ResetPassword;
  } else {
    hotjarAction = urlPathName;
  }

  Hotjar.event(hotjarAction);
};

export const connectConceptualHqSnippet = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if ((window as any).ConceptualAnalytics) {
    return;
  }

  const apiKey = process.env.REACT_APP_CONCEPTUAL_HQ_TOKEN;

  if (!apiKey) {
    console.warn('Conceptual HQ API key not found');

    return;
  }

  const script = document.createElement('script');

  script.async = true;
  script.src = `https://ouruhg.hfsfinancial.net/analytics/loader-v1.js?key=${apiKey}`;

  const windowVariable = window as any;

  windowVariable.ConceptualAnalytics = function (...args: any[]) {
    (windowVariable.ConceptualAnalytics.q = windowVariable.ConceptualAnalytics.q || []).push(args);
  };
  windowVariable.ConceptualAnalytics.l = new Date().getTime();

  document.head.appendChild(script);
};

export const getConceptualDeviceId = async (): Promise<string | null> => {
  for (let i = 0; i < GET_CONCEPTUAL_DEVICE_ID_MAX_ATTEMPTS; i++) {
    const deviceId = Cookies.get(CONCEPTUAL_DEVICE_ID_COOKIE);

    if (deviceId) {
      return deviceId;
    }

    // eslint-disable-next-line @typescript-eslint/no-loop-func
    await new Promise((resolve) => setTimeout(resolve, GET_CONCEPTUAL_DEVICE_ID_RETRY_DELAY_MS));
  }

  return null;
};
